import { render, staticRenderFns } from "./Bandwidth.vue?vue&type=template&id=5d59cf40&scoped=true"
import script from "./Bandwidth.vue?vue&type=script&setup=true&lang=js"
export * from "./Bandwidth.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Bandwidth.vue?vue&type=style&index=0&id=5d59cf40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d59cf40",
  null
  
)

export default component.exports